module.exports = __webpack_public_path__ + "static/img/newHuaiC3.37f280e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/newHuaiC3.png
// module id = QNa+
// module chunks = 0